module.exports = __webpack_public_path__ + "static/media/LightCheckBox.94d01811.svg";